<template>
  <div class="page-content--bgf7">
    <section class="au-breadcrumb2">
      <div class="container m-b-60">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex justify-space-between">
              <h5 class="text-18 ">
                <v-list-item-avatar>
                  <v-img
                    contain
                    class="grey"
                    :src="channel.watermarkPicture && channel.watermark.enabled ?
                      channel.watermarkPicture : channel.logo"
                  />
                </v-list-item-avatar>
                Manual Scheduler
              </h5>

              <v-btn
                text
                color="primary"
                @click="goToRules()"
              >
                <i class="fas fa-cog m-r-5" />Manage Scheduler
              </v-btn>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 p-t-0">
            <v-sheet
              elevation="1"
              max-height="400px"
              class="pa-3 d-flex flex-column"
            >
              <v-text-field
                v-model="query"
                label="Asset search"
                dense
                clearable
                append-icon="mdi-magnify"
                hide-details
                @input="debouncedFetch"
                class="p-b-10"
              />

              <!--v-row
                dense
                class="mt-2"
              >
                <v-col cols="6">
                  <v-select
                    v-model="sort"
                    :items="sortOptions"
                    dense
                    label="Сортировка"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model.number="durationFilter"
                    label="Мин. длит. (мин)"
                    dense
                    type="number"
                    @input="fetchAssets"
                  />
                </v-col>
              </v-row-->

              <div
                ref="assetScroll"
                class="flex-grow-1 overflow-y-auto"
                @scroll.passive="handleScroll"
              >

                <v-list dense>
                  <draggable
                    v-model="assets"
                    :group="{ name: 'events', pull: 'clone', put: false }"
                    :clone="cloneItem"
                    :animation="150"
                  >
                  <v-list-item
                    v-for="asset in assets"
                    :key="asset.id"
                    class="asset-tile"
                    :data-duration="asset.duration"
                    @mouseenter="asset.vis = true"
                    @mouseleave="asset.vis = false"
                  >
                    <div class="bar" />
                    <div class="text">{{ asset.title }} ({{ asset.duration }} мин)</div>
                    <v-btn
                      v-if="asset.vis"
                      class="ml-2 px-2 border rounded bg-blue-200"
                      x-small
                      text
                      @click="promptTime(asset)"
                    >
                      Set time
                    </v-btn>
                  </v-list-item>
                  </draggable>
                </v-list>

                <div v-if="!assetLoading && assets.length === 0" class="text-center grey--text py-4">
                  <v-icon color="grey lighten-1" class="mb-1">mdi-database-off</v-icon>
                  <div>No data</div>
                </div>

                <v-progress-circular
                  v-if="assetLoading"
                  indeterminate
                  size="20"
                  color="primary"
                  class="my-2 mx-auto d-block"
                />
              </div>
            </v-sheet>

            <!--v-card>
              <v-card-title>Assets</v-card-title>

              <div
                v-if="true || !newEventDialog && selectedEvent.event.program && selectedEvent.event.program.id"
                class="p-b-0"
                :loading="selectedEvent && selectedEvent.event.loading === true"
              >
                <div class="source-block">
                  <draggable
                    v-model="assets"
                    :group="{ name: 'events', pull: 'clone', put: false }"
                    :clone="cloneItem"
                    :animation="150"
                  >
                    <div
                      v-for="program in assets"
                      :key="program.id"
                      class="source-item d-flex justify-space-between"
                      @mouseenter="program.vis = true"
                      @mouseleave="program.vis = false"
                    >
                      {{ program.title }} ({{ program.duration }} мин)
                      <v-btn
                        v-if="program.vis"
                        class="ml-2 px-2 border rounded bg-blue-200"
                        x-small
                        text
                        @click="promptTime(program)"
                      >
                        Задать время
                      </v-btn>
                    </div>
                  </draggable>
                </div>
              </div>
            </v-card-->

            <v-card class="mt-4">
              <schedule-calendar
                :schedule="schedule"
                :current-date="currentDate"
                @update:current-date="val => currentDate = val"
                @day-click="handleDayClick"
              />
            </v-card>
          </div>
          <div
            class="col-md-8 pr-0 p-t-0"
            style="padding-left: 15px !important;"
          >
            <v-card>
              <v-sheet
                style="background-color: transparent;"
              >
                <div
                  v-if="currentDayObj"
                  class="d-flex justify-space-between"
                >
                  <v-card-title>     <i class="zmdi zmdi-calendar p-r-5" />         {{ moment(currentDayObj.start).utc().format('dddd, D MMMM') }}</v-card-title>
                  <div class="p-t-20">
                    <v-btn
                      v-if="currentDayObj.events"
                      text
                      small
                      @click="clear()"
                    >
                      <i class="mdi mdi-delete-sweep p-r-5" />clear
                    </v-btn>
                    <v-btn
                      v-if="false && currentDayObj.events === 0"
                      class="m-l-10"
                      text
                      small
                      @click="randomDayDialog = true"
                    >
                      <i class="fas fa-random p-r-5" />random day's EPG
                    </v-btn>
                    <v-btn
                      v-if="false && week.locked"
                      class="m-l-10"
                      text
                      @click.prevent="lockWeek(false)"
                    >
                      <i class="fas fa-lock-open p-r-5" />
                      Unlock week
                    </v-btn>
                    <v-btn
                      text
                      small
                      :color="isDirty ? 'primary' : 'grey'"
                      :disabled="!isDirty"
                      @click.prevent="lockWeek(true)"
                    >
                      <i class="fas fa-save p-r-5" />
                      Save
                    </v-btn>
                  </div>
                </div>

                <div class="timeline">
                  <div class="timeline-grid">
                    <div
                      v-for="n in 144"
                      :key="n"
                      class="tick"
                      :class="{ 'hour': n % 6 === 0 }"
                    />
                  </div>
                  <div class="timeline-labels">
                    <div
                      v-for="h in 24"
                      :key="h"
                      class="label"
                    >
                      {{ (h - 1).toString() }}
                    </div>
                  </div>
                  <div class="timeline-fill">
                    <div
                      v-for="event in schedule"
                      :key="event.id"
                      class="fill"
                      :style="{
                        left: calculatePosition(event.start) + '%',
                        width: calculateWidth(event.duration) + '%'
                      }"
                    />
                  </div>
                </div>

                <span class="text-gray-500">
                  Events: {{ someDay.events }} ___ Gaps Count: {{ someDay.gaps }} ___ Gaps Duration: {{ (someDay.gapsDuration / 1000 / 60 / 60).toFixed(1) }} h ___
                  Occupancy: {{ someDay.occupancy }}
                </span>
                <table
                  class="table no-column-borders1 schedule-table"
                  style="table-layout: fixed; width: 100%;"
                >
                  <thead>
                    <tr>
                      <th style="width: 90px !important;">
                        Start
                      </th>
                      <th style="width: 90px !important;">
                        End
                      </th>
                      <th>Name</th>
                      <th />
                      <th style="width: 90px" />
                    </tr>
                  </thead>
                  <!-- Здесь tbody оборачивается в компонент draggable -->

                  <draggable
                    v-model="schedule"
                    :options="{ draggable: '.draggable-row:not(.non-draggable)' }"
                    tag="tbody"
                    :group="{ name: 'events', pull: true, put: true }"
                    :animation="200"
                    @add="onItemAdd"
                    @end="onDragEnd"
                    @change="checkConflicts"
                  >
                    <tr
                      v-for="event in schedule"
                      :key="event.id"
                      class="draggable-row"
                      :class="{ 'non-draggable33': event.isGap, 'anchor-gradient': event.anchor, 'gap-indicator': event.isGap, 'overflow-row': event.overflow}"
                    >
                      <td style="width: 90px !important;">
                        {{ event.start }}
                      </td>
                      <td style="width: 90px;">
                        {{ event.end }}
                      </td>
                      <td>{{ event.title }}</td>
                      <td>
                        <span
                          v-if="event.conflict"
                          class="error--text font-bold conflict-badge"
                        >Conflict
                        </span>

                        <span
                          v-if="event.overflow"
                          class="error--text font-bold conflict-badge"
                        >Overflow
                        </span>

                        <span v-if="event.isGap">
                          ⏳ Gap after
                        </span>
                      </td>
                      <td class="text-right">
                        <!-- 1. Якорь -->
                        <v-icon
                          small
                          class="mr-2 cursor-pointer"
                          :color="event.anchor ? 'blue darken-2' : 'grey'"
                          title="Toggle anchor"
                          @click="event.anchor = !event.anchor"
                        >
                          {{ event.anchor ? 'mdi-anchor' : 'mdi-anchor' }}
                        </v-icon>

                        <!-- 2. Редактировать время -->
                        <v-icon
                          small
                          class="mr-2"
                          title="Edit start time"
                          @click="editEventTime(event)"
                        >
                          mdi-clock-edit-outline
                        </v-icon>

                        <!-- 3. Удалить -->
                        <v-icon
                          small
                          color="red"
                          title="Delete"
                          @click="deleteEvent(event.id)"
                        >
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </draggable>

                <!-- Отображаем текущие данные таблицы для контроля -->
                <!--pre>{{ scheduleWithGaps }}</pre-->

                <!--draggable
                  v-model="schedule"
                  :options="{ draggable: '.draggable-row:not(.non-draggable)' }"
                  tag="tbody"
                  :group="{ name: 'events', pull: true, put: true }"
                  :animation="200"
                  @add="onItemAdd"
                  @end="onDragEnd"
                  @change="checkConflicts"
                >
                  <tr
                    v-for="event in schedule"
                    :key="event.id"
                    class="draggable-row"
                    :class="{ 'non-draggable1': event.anchor, 'anchor-gradient': event.anchor}"
                  >
                    <td>{{ event.start }}</td>
                    <td>{{ event.end }}</td>
                    <td>{{ event.title }}</td>
                    <td>
                      <span
                        class="mr-2 cursor-pointer"
                        @click="event.anchor = !event.anchor"
                      >
                        <i :class="event.anchor ? 'mdi mdi-anchor text-gray-800' : 'mdi mdi-anchor-outline text-gray-400'" />
                      </span>

                      <span
                        v-if="event.conflict"
                        class="error--text font-bold"
                      >(Conflict!)</span>
                    </td>
                  </tr>
                </draggable-->
                </table>
              </v-sheet>
            </v-card>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 p-t-0 p-l-15">
            <v-card dark>
              <iframe
                id="streamFrameSrc"
                :src="streamFrameSrc"
                width="100%"
                scrolling="no"
                height="198"
                frameborder="0"
              />
            </v-card>
          </div>
          <div class="col-md-8 p-l-10 p-t-0 p-b-0">
            <v-card>
              <!--v-row>
                <div class="col-md-5 p-t-0 p-b-0 p-r-0">
                  <div
                    v-if="loading"
                    class="el-loading-mask"
                  >
                    <div class="el-loading-spinner">
                      <svg
                        viewBox="25 25 50 50"
                        class="circular"
                      >
                        <circle
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                          class="path"
                        />
                      </svg>
                    </div>
                  </div>
                  <table class="table table-sm table-bordered">
                    <tr
                      v-for="w in weeks"
                      :key="w.text"
                      class="pointer"
                      :class="{ 'primary white--text': w.text === week.text }"
                      @click="changeWeek(w)"
                    >
                      <td
                        v-ripple
                        class="text-body-2"
                        style="width: 260px;"
                      >
                        <i
                          v-if="w.locked"
                          class="fas fa-lock p-r-10 grey--text"
                        />
                        <v-badge
                          v-if="w.text === weekObj.text"
                          :color="w.text === week.text ? 'white': 'primary'"
                          offset-x="0"
                          offset-y="8"
                          dot
                        >
                          {{ w.text }}
                        </v-badge>
                        <span v-else>
                          {{ w.text }}
                        </span>
                      </td>
                      <td
                        v-ripple
                        class="text-body-2"
                      >
                        {{ w.occupancy }}%
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-md-7 p-t-0 p-b-0 p-l-0">
                  <v-card>
                    <div
                      v-if="loading"
                      class="el-loading-mask"
                    >
                      <div class="el-loading-spinner">
                        <svg
                          viewBox="25 25 50 50"
                          class="circular"
                        >
                          <circle
                            cx="50"
                            cy="50"
                            r="20"
                            fill="none"
                            class="path"
                          />
                        </svg>
                      </div>
                    </div>
                    <table class="table table-sm table-bordered">
                      <tr
                        v-for="day in week.days"
                        :key="day.v"
                        class="pointer"
                        :class="{ 'primary white--text': calendarDay === day.v }"
                        @click="changeDay(day)"
                      >
                        <td
                          v-ripple
                          class="text-body-2"
                          style="width: 150px;"
                        >
                          <i class="zmdi zmdi-calendar p-r-10" />
                          <v-badge
                            v-if="day.v === currentDay"
                            :color="calendarDay === day.v ? 'white': 'primary'"
                            offset-x="0"
                            offset-y="8"
                            dot
                          >
                            {{ day.text }}
                          </v-badge>
                          <span v-else>
                            {{ day.text }}
                          </span>
                        </td>
                        <td class="text-body-2">
                          <span
                            :class="{
                              'green--text text--darken-3': day.occupancy >= 90 && calendarDay !== day.v,
                              'white--text': calendarDay === day.v
                            }"
                          >
                            {{ day.occupancy }}%
                          </span>
                          <span
                            v-if="day.events"
                            class="p-l-20"
                          >
                            {{ day.events }}
                            <span v-if="!day.overlays.length">
                              event<span v-if="day.events === 0 || day.events > 1">s</span>
                            </span>
                          </span>
                          <v-icon
                            v-if="day.overlays.length"
                            small
                            class="p-l-20"
                          >
                            mdi-image-filter-none
                          </v-icon>
                          <span
                            v-if="day.overlays.length"
                            style="color: #FF8A80"
                          >
                            <strong>{{ day.overlays.length }}</strong>
                          </span>
                        </td>
                      </tr>
                    </table>
                  </v-card>
                </div>
              </--v-row-->
            </v-card>
          </div>
        </div>
      </div>
    </section>
    <!-- Player dialog -->
    <v-bottom-sheet
      v-model="openPlayer"
      max-width="960"
      :persistent="false"
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ player.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ player.description }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closeStream()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <v-dialog
      v-model="editDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>Редактировать время</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editedStart"
            label="Начало (HH:mm)"
            prepend-icon="mdi-clock-outline"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="editDialog = false"
          >
            Отмена
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="saveEditedTime"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import {
    processChannel, processTimezone, processProgram2, processDistribution,
  } from '@/store/converters'
  import draggable from 'vuedraggable'
  import ScheduleCalendar from './ScheduleCalendar.vue'

  export default {
    components: { draggable, ScheduleCalendar },
    data () {
      return {
        programs: [
          { id: 1, title: 'Новости', duration: 60, vis: false, anchor: false },
          { id: 2, title: 'Фильм', duration: 120, vis: false, anchor: false },
          { id: 3, title: 'Шоу', duration: 30, vis: false, anchor: false },
          { id: 4, title: 'Реклама', duration: 5, vis: false, anchor: false },
        ],
        schedule: [
          { id: 100, title: 'Show', start: '10:30', end: '11:00', conflict: false, anchor: false, duration: 30 },
          { id: 101, title: 'Новости', start: '12:00', end: '13:00', conflict: false, anchor: true, duration: 60 },
          { id: 102, title: 'Фильм', start: '13:00', end: '15:00', conflict: true, anchor: false, duration: 120 },
        ],

        scheduleWithGaps: [],

        sourceItems: [
          { id: 101, name: 'New Item 1', sport: 'Tennis' },
          { id: 102, name: 'New Item 2', sport: 'Baseball' },
          { id: 103, name: 'New Item 3', sport: 'Hockey' },
        ],
        // Элементы, отображаемые в таблице
        tableItems: [
          { id: 1, name: 'Abby', sport: 'Basketball' },
          { id: 2, name: 'Brooke', sport: 'Soccer' },
          { id: 3, name: 'Courtenay', sport: 'Volleyball' },
          { id: 4, name: 'David', sport: 'Rugby' },
        ],
        //
        polling: null,
        currentT: null,
        currentUnixTime: moment().utc().unix() * 1000,
        today: null,
        tzOffset: 0,
        currentDayObj: null,
        currentDay: null,
        calendarDay: '',
        dayLoading: false,
        week: {
          text: '',
          days: [],
        },
        weeks: [],
        weekObj: null,
        activeCol: -1,
        //
        calendarInterval: {
          current: 0,
          min: 48,
          max: 1200,
        },
        //
        channel: {
          streamURL: '',
        },
        streamFrameSrc: '',
        //
        allEvents: [],
        events: [],
        //
        currentEvent: null,
        selectedEvent: {
          loading: false,
          event: {},
        },
        //
        newEventDialog: false,
        newProgram: {
          loaded: false,
          type: 'once',
          date: '',
        },
        //
        openPlayer: false,
        frameSrc: '',
        player: {
          name: '',
          description: '',
        },
        //
        clearDayDialog: false,
        randomDayDialog: false,
        randomDay: {
          minDuration: 2,
          maxDuration: 300,
        },

        someDay: { startT: null },
        currentDate: null,
        editDialog: false,
        editedEvent: null,
        editedStart: null, // тут будет строка вида 'HH:mm
        initialHash: '',
        isDirty: false,
        assetLoading: false,
        durationFilter: 5,
        done: false,
        debounceTimer: null,
        assets: [],
        query: '',
        limit: 20,
        offset: 0,
        page: 1,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      defaultIcon () {
        return '/images/ch_icon.png'
      },
      defaultPoster () {
        return '/images/poster2x3.jpg'
      },
      nowY () {
        if (!this.currentT) return 0
        const hours = Number(this.currentT.format('H'))
        const min = parseInt(this.currentT.format('mm'), 10)
        return `${Math.ceil(this.calendarInterval.current * hours + (this.calendarInterval.current / 60) * min)}px`
      },
      playedProgress () {
        if (!this.currentEvent) return 0
        // eslint-disable-next-line max-len
        const eventDuration = this.currentEvent.endOriginal - this.currentEvent.startOriginal
        // eslint-disable-next-line no-mixed-operators
        return (this.currentUnixTime - this.currentEvent.startOriginal) * 100 / eventDuration
      },
      currentDayEvents () {
        const events = []

        const offset = new Date().getTimezoneOffset() * 60 * 1000

        for (let j = 0; j < this.schedule.length; j += 1) {
          const event = this.schedule[j]
          if ((event.startT.getTime() - offset > this.someDay.start && event.startT.getTime() - offset < this.someDay.end) ||
            (event.endT.getTime() - offset > this.someDay.start && event.endT.getTime() - offset < this.someDay.end)) {
            events.push(event)
          }
        }

        return events
      },
    },
    watch: {
      currentDate (newVal, oldValue) {
        console.log('📅 Текущая дата изменилась:', newVal, 'OLD:', oldValue)
        // можешь здесь вызывать обновление, например:
        // this.highlightDay(newVal);

        if (oldValue) this.handleDayClick(newVal)
      },
      schedule: {
        handler () {
          const currentHash = this.computeScheduleHash(this.schedule)
          this.isDirty = currentHash !== this.initialHash
        },
        deep: true,
      },
    },
    mounted () {
      this.updateTime()
      this.initialHash = this.computeScheduleHash(this.schedule)
      this.fetchAssets(true);
    },
    created () {
      const channelId = this.$route.params.id

      this.loadData(channelId)
      const savedInt = localStorage.getItem('calendarInterval')
      this.calendarInterval.current = savedInt ? Number(savedInt) : this.calendarInterval.min * 2

      this.caclscheduleWithGaps()

      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const date = today.getDate()

      this.schedule.forEach(item => {
        const [startH, startM] = item.start.split(':').map(Number)
        const [endH, endM] = item.end.split(':').map(Number)

        item.startT = new Date(year, month, date, startH, startM)
        item.endT = new Date(year, month, date, endH, endM)
      })

      let tz = 'UTC'
      if (this.channel.timezone) {
        tz = this.channel.timezone.name
      }
      const now = moment.tz(tz)

      this.someDay.start = now.clone().startOf('day').valueOf()
      this.someDay.end = now.clone().endOf('day').valueOf()
      this.someDay.startT = now.clone().startOf('day')
      this.someDay.endT = now.clone().endOf('day')

      this.currentDate = new Date(this.someDay.startT)

      this.checkConflicts1()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      async fetchAssets (reset = false) {
        if (this.assetLoading || this.done) return
        this.assetLoading = true

        if (reset) {
          this.assets = []
          this.page = 1
          this.done = false
        }

        const args = {
          q: this.query,
          sort: this.sort,
          duration: this.durationFilter,
          $limit: this.limit,
          $offset: this.limit * this.page - this.limit,
          $orderby: '-id',
          'state[eq]': 'ready',
          //page: this.page,
        }

        //if (this.query) {
          args.$match = this.query
        //}

        const result = await this.$store.dispatch('assets', args)

        if (Array.isArray(result)) {
          const normalized = result.map(item => ({
            id: item.id,
            title: item.name,
            duration: Math.round(item.duration / 60),
            vis: false, anchor: false,
          }));

          if (reset) {
            this.assets = normalized;
          } else {
            this.assets.push(...normalized);
          }

           this.page += 1;
          //if (normalized.length === 0) this.done = true;
        }

        this.assetLoading = false
      },
      handleScroll() {
        const el = this.$refs.assetScroll;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
          this.fetchAssets();
        }
      },
      debouncedFetch() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.fetchAssets(true), 400);
      },
      computeScheduleHash (schedule) {
        const normalized = schedule.map(e => ({
          id: e.id,
          title: e.title,
          start: e.start,
          end: e.end,
          duration: e.duration,
          anchor: e.anchor,
        }))
        return JSON.stringify(normalized)
      },
      saveSchedule () {
        this.initialHash = this.computeScheduleHash(this.schedule)
      },
      caclscheduleWithGaps () {
        console.log('scheduleWithGaps')

        const result = []
        // const sorted = [...this.schedule].sort((a, b) => this.parseTime(a.start) - this.parseTime(b.start))
        for (let i = 0; i < this.schedule.length; i++) {
          const current = this.schedule[i]
          result.push(current)
          const currentEnd = new Date(this.parseTime(current.start).getTime() + current.duration * 60000)
          const next = this.schedule[i + 1]
          if (next) {
            const nextStart = this.parseTime(next.start)
            if (currentEnd < nextStart) {
              result.push({
                id: Date.now() + this.formatTime(currentEnd),
                isGap: true,
                start: this.formatTime(currentEnd),
                end: this.formatTime(nextStart),
              })
            }
          }
        }

        this.scheduleWithGaps = result
      },
      formatTime (date) {
        const h = date.getHours().toString().padStart(2, '0')
        const m = date.getMinutes().toString().padStart(2, '0')
        return `${h}:${m}`
      },
      calculatePosition (start) {
        if (!start) return
        const [h, m] = start.split(':')
        return ((+h * 60 + +m) / 1440) * 100
      },
      calculateWidth (duration) {
        return (duration / 1440) * 100
      },
      parseTime (t) {
        const [h, m] = t.split(':')
        const date = new Date()
        date.setHours(h, m, 0)
        return date
      },
      promptTime (program) {
        const time = prompt(`Введите время начала для программы \"${program.title}\":`, '12:00')

        if (time) {
          const currStart = this.parseTime(time)
          const currEnd = new Date(currStart.getTime() + program.duration * 60000)

          const hours = currEnd.getHours().toString().padStart(2, '0')
          const minutes = currEnd.getMinutes().toString().padStart(2, '0')

          this.schedule.push({
            id: Date.now(),
            title: program.title,
            start: time,
            end: `${hours}:${minutes}`,
            startT: currStart,
            endT: currEnd,
            duration: program.duration,
            conflict: false,
            anchor: false,
          })

          this.checkConflicts1()
        }
      },
      checkConflicts () {
        return
        this.schedule.sort((a, b) => this.parseTime(a.start) - this.parseTime(b.start))

        for (let i = 0; i < this.schedule.length; i++) {
          this.schedule[i].conflict = false
          const currStart = this.parseTime(this.schedule[i].start)
          const currEnd = new Date(currStart.getTime() + this.schedule[i].duration * 60000)

          if (i < this.schedule.length - 1) {
            const nextStart = this.parseTime(this.schedule[i + 1].start)
            if (currEnd > nextStart) {
              this.schedule[i].conflict = true
              this.schedule[i + 1].conflict = true
            }
          }
        }
      },
      checkConflicts1 () {
        // Сортируем по startT, затем по endT
        this.schedule.sort((a, b) => {
          if (a.startT.getTime() !== b.startT.getTime()) {
            return a.startT - b.startT
          }
          return a.endT - b.endT
        })

        // Сброс флагов
        this.schedule.forEach(item => {
          item.conflict = false
          item.isGap = false
          item.overflow = false
        })

        // Проверка на конфликты и дыры
        /*        for (let i = 0; i < this.schedule.length; i++) {
          const currStart = this.schedule[i].startT
          const currEnd = new Date(currStart.getTime() + this.schedule[i].duration * 60000)

          if (i < this.schedule.length - 1) {
            const nextStart = this.schedule[i + 1].startT
            if (currEnd > nextStart) {
              this.schedule[i].conflict = true
              this.schedule[i + 1].conflict = true
            }
            if (currEnd < nextStart) {
              this.schedule[i].isGap = true
            }
          }
        } */

        const endOfDay = new Date()
        endOfDay.setHours(23, 59, 59, 999)

        this.schedule.forEach(item => {
          item.overflow = item.startT > endOfDay
        })

        for (let i = 0; i < this.schedule.length - 1; i++) {
          const current = this.schedule[i]
          const next = this.schedule[i + 1]

          if (current.endT > next.startT) {
            current.conflict = true
            next.conflict = true
          } else if (current.endT < next.startT) {
            current.isGap = true
          }
        }

        console.log('here')

        this.calcDay2()
      },
      checkConflicts11 () {
        this.schedule.sort((a, b) => {
          const startA = this.parseTime(a.start)
          const startB = this.parseTime(b.start)

          if (startA.getTime() !== startB.getTime()) {
            return startA - startB
          }

          const endA = new Date(startA.getTime() + a.duration * 60000)
          const endB = new Date(startB.getTime() + b.duration * 60000)

          return endA - endB
        })

        // this.schedule.sort((a, b) => this.parseTime(a.start) - this.parseTime(b.start))

        for (let i = 0; i < this.schedule.length; i++) {
          this.schedule[i].conflict = false
          const currStart = this.parseTime(this.schedule[i].start)
          const currEnd = new Date(currStart.getTime() + this.schedule[i].duration * 60000)

          if (i < this.schedule.length - 1) {
            const nextStart = this.parseTime(this.schedule[i + 1].start)
            if (currEnd > nextStart) {
              this.schedule[i].conflict = true
              this.schedule[i + 1].conflict = true
            }
          }
        }

        for (let i = 0; i < this.schedule.length; i++) {
          this.schedule[i].isGap = false
          const currentEnd = new Date(this.parseTime(this.schedule[i].start).getTime() + this.schedule[i].duration * 60000)
          const next = this.schedule[i + 1]
          if (next) {
            const nextStart = this.parseTime(next.start)
            if (currentEnd < nextStart) {
              this.schedule[i].isGap = true
            }
          }
        }
      },
      cloneItem (item) {
        console.log('cloneItem', item)
        // Возвращаем копию объекта (если нужно глубоко клонировать, можно использовать JSON.parse(JSON.stringify(item)))
        return { ...item }
      },
      // Вызывается после завершения операции (перетаскивания внутри таблицы)
      onDragEnd (evt) {
        console.log('Перетаскивание завершено. Текущий порядок таблицы:', this.tableItems)
        this.reorder(evt.newIndex)
      },
      clear () {
        this.schedule = []
      },
      canMove (evt) {
        console.log('Перемещаемыйе:', evt)

        const current = this.schedule[evt.oldIndex]
        const prev = null
        const next = null

        // return !evt.draggedContext.element.anchor;
      },

      // Вызывается, когда элемент из внешнего блока перенесли в таблицу

      reorder (currIndex) {
        const current = this.schedule[currIndex]
        if (current.anchor) {
          this.checkConflicts1()
          return
        }

        let prev = null
        let next = null

        if (currIndex > 0) {
          prev = this.schedule[currIndex - 1]
          console.log('prev', prev.start, prev.end, prev.title)

          const prevEnd = prev.endT

          const hours = prevEnd.getHours().toString().padStart(2, '0')
          const minutes = prevEnd.getMinutes().toString().padStart(2, '0')
          current.start = `${hours}:${minutes}`
          current.startT = prev.endT
        } else {
          current.start = '00:00'

          const today = new Date()
          const year = today.getFullYear()
          const month = today.getMonth()
          const date = today.getDate()
          const [h, m] = '00:00'.split(':').map(Number)
          current.startT = new Date(year, month, date, h, m)
        }

        const currStart = current.startT
        const currEnd = new Date(currStart.getTime() + current.duration * 60000)
        const hours = currEnd.getHours().toString().padStart(2, '0')
        const minutes = currEnd.getMinutes().toString().padStart(2, '0')
        current.end = `${hours}:${minutes}`
        current.endT = currEnd

        if (currIndex + 1 <= this.schedule.length - 1) {
          next = this.schedule[currIndex + 1]
          console.log('next', next.start, next.end, next.title)
          const nextStart = next.startT

          console.log('nextStart', nextStart)

          if (nextStart > currEnd) {
            this.checkConflicts1()
            return
          }
        }

        for (let i = currIndex + 1; i < this.schedule.length; i++) {
          if (this.schedule[i].anchor) {
            continue
          }

          const prevEnd = this.schedule[i - 1].endT
          let hours = prevEnd.getHours().toString().padStart(2, '0')
          let minutes = prevEnd.getMinutes().toString().padStart(2, '0')
          this.schedule[i].start = `${hours}:${minutes}`
          this.schedule[i].startT = prevEnd

          const currEnd = new Date(prevEnd.getTime() + this.schedule[i].duration * 60000)
          hours = currEnd.getHours().toString().padStart(2, '0')
          minutes = currEnd.getMinutes().toString().padStart(2, '0')
          this.schedule[i].end = `${hours}:${minutes}`
          this.schedule[i].endT = currEnd
        }

        this.checkConflicts1()
      },

      onItemAdd (evt) {
        console.log('Элемент добавлен в таблицу:', evt)

        const program = this.assets[evt.oldIndex]
        program.id = Date.now()
        console.log('----duration', program.duration)

        let prev = null
        let next = null

        let gapCount = 0
        /*        for (let i =  0; i <= evt.newIndex; i++) {
          if (this.scheduleWithGaps[i].isGap) {
            gapCount++
          }
        } */

        gapCount = 0

        console.log('this.schedule', this.schedule[evt.newIndex])
        this.schedule[evt.newIndex].anchor = false

        console.log('----gapCount', gapCount)

        const current = this.schedule[evt.newIndex - gapCount]
        current.id = Date.now()

        console.log('----current', current)

        this.reorder(evt.newIndex - gapCount)
        this.caclscheduleWithGaps()
        return

        if (evt.newIndex > 0) {
          prev = this.schedule[evt.newIndex - 1]
          console.log('prev', prev.start, prev.end, prev.title)

          const prevEnd = this.parseTime(prev.end)

          const hours = prevEnd.getHours().toString().padStart(2, '0')
          const minutes = prevEnd.getMinutes().toString().padStart(2, '0')
          current.start = `${hours}:${minutes}`
        } else {
          current.start = '00:00'
        }

        //
        const currStart = this.parseTime(current.start)
        const currEnd = new Date(currStart.getTime() + program.duration * 60000)
        const hours = currEnd.getHours().toString().padStart(2, '0')
        const minutes = currEnd.getMinutes().toString().padStart(2, '0')
        current.end = `${hours}:${minutes}`
        //

        if (evt.newIndex + 1 <= this.schedule.length - 1) {
          next = this.schedule[evt.newIndex + 1]
          console.log('next', next.start, next.end, next.title)
          const nextStart = this.parseTime(next.start)

          console.log('nextStart', nextStart)

          if (nextStart > currEnd) {
            this.checkConflicts1()
            return
          }
        }

        for (let i = evt.newIndex + 1; i < this.schedule.length; i++) {
          if (this.schedule[i].anchor) {
            continue
          }

          const prevEnd = this.parseTime(this.schedule[i - 1].end)
          let hours = prevEnd.getHours().toString().padStart(2, '0')
          let minutes = prevEnd.getMinutes().toString().padStart(2, '0')
          this.schedule[i].start = `${hours}:${minutes}`

          const currEnd = new Date(prevEnd.getTime() + this.schedule[i].duration * 60000)
          hours = currEnd.getHours().toString().padStart(2, '0')
          minutes = currEnd.getMinutes().toString().padStart(2, '0')
          this.schedule[i].end = `${hours}:${minutes}`
        }

        this.checkConflicts1()
        // evt содержит информацию о новом индексe (evt.newIndex) и об удалённом элементе, если используется move
        // Если вы хотите, например, назначить новый id для элемента, можно это сделать здесь.
      },

      loadData (channelId) {
        this.$store.commit('setPageLoader')

        const tzReq = this.$store.dispatch('timezones')
        const args = {
          ids: channelId,
          expand: 'timezone,logo,watermark',
        }
        const channelReq = this.$store.dispatch('channels', args)

        const distribReqArgs = {
          'default[eq]': 1,
          'channel.id[eq]': channelId,
        }
        const distribReq = this.$store.dispatch('distributions', distribReqArgs)

        return Promise.all([tzReq, channelReq, distribReq])
          .then((res) => {
            const timezones = res[0]
            this.timezones = timezones.map((tz) => processTimezone(tz))

            const channels = res[1]
            this.channel = processChannel(channels[0])

            const duration = moment.duration(this.channel.autoSchedulerDepth, 'minutes')
            this.channel.autoSchedulerDepthStr = `${duration.hours()} hours ${duration.minutes()} minutes`
            if (duration.days()) {
              this.channel.autoSchedulerDepthStr = `${duration.days()} days ${this.channel.autoSchedulerDepthStr}`
            }

            let streamURL = this.channel.streamURLhlsv3

            const distributions = res[2] || []
            if (distributions.length) {
              const processed = processDistribution(distributions[0])
              for (const key in processed.urls) {
                if (key === 'hls3') {
                  streamURL = processed.urls[key]
                }
              }
            }

            streamURL = streamURL.replace('$origin', 'now')
            streamURL = streamURL.replace('$offset', '-1m_15s')
            streamURL = streamURL.replace(',', '_')

            this.channel.streamURL = streamURL
            this.streamFrameSrc = `/js/radiant/index3.html?src=${streamURL}`

            // eslint-disable-next-line max-len
            this.tzOffset = moment.tz(moment.tz.guess()).utcOffset() * 60 * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000
            this.currentDay = moment.utc(moment().utc().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).format('YYYY-MM-DD')
            this.currentT = moment().tz(this.channel.timezone.name)

            this.buildWeeks()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      buildWeeks () {
        this.$store.commit('setPageLoader')
        let w = moment.utc(moment().utc().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).startOf('isoWeek').subtract(7, 'days')

        const locked = !!this.channel.autoScheduler

        this.weeks = []
        for (let i = 0; i < 7; i += 1) {
          const t = w.clone()
          const startOfWeek = t.format('MMMM D')
          const startOfWeekM = t.format('MMMM')
          const number = t.week()
          const days = []
          let lastEnd = moment()
          for (let j = 0; j < 7; j += 1) {
            const start = moment(`${t.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000
            const end = moment(`${t.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000

            const newDay = {
              v: t.format('YYYY-MM-DD'),
              text: t.format('MMMM D'),
              start,
              end,
              overlays: [],
              gaps: 0,
              gapsDuration: 0,
              events: 0,
            }
            t.add(1, 'days')
            if (newDay.v === this.currentDay) {
              this.currentDayObj = newDay
              this.today = newDay
            }
            days.push(newDay)
            lastEnd = moment.utc(end + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000)
          }
          w = w.add(7, 'days')
          const endOfWeek = lastEnd.format('MMMM') === startOfWeekM ? lastEnd.utc().format('D') : lastEnd.utc().format('MMMM D')
          const newWeek = {
            text: `${startOfWeek} - ${endOfWeek}`,
            days,
            number,
            occupancy: 0,
            locked,
          }
          // init
          if (i === 1) {
            this.week = newWeek
            this.weekObj = newWeek
            this.calendarDay = this.currentDay
            this.newProgram.date = this.currentDay
          }
          this.weeks.push(newWeek)
        }
        if (!this.channel.autoScheduler) {
        // this.getBlockedWeeks();
        }
        this.getWeekStat()
        this.getPrograms(true)
      },
      getWeekStat () {
        const data = {
          query: [],
          channel: { id: this.channel.id },
        }
        for (let i = 0; i < this.weeks.length; i += 1) {
          data.query.push({
            start: `${moment(this.weeks[i].days[0].start).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
            end: `${moment(this.weeks[i].days[this.week.days.length - 1].end).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          })
        }

        this.$store.dispatch('scheduleLoading', data)
          .then((result) => {
            for (let i = 0; i < result.query.length; i += 1) {
              this.weeks[i].occupancy = result.query[i].occupancy
            }
          /*          let gapsDuration = 0;
          for (let i = 0; i < this.week.days.length; i += 1) {
            gapsDuration += this.week.days[i].gapsDuration;
          }
          const gapPr = (gapsDuration * 100) / (7 * 60 * 60 * 24 * 1000);
          // eslint-disable-next-line no-console
          console.log('occupancy', Math.round((100 - gapPr) * 100) / 100); */
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      changeWeek (week) {
        this.week = week
        this.getPrograms()
        this.calendarDay = this.week.days[0].v
        this.newProgram.date = this.calendarDay
        this.changeDay(this.week.days[0])
      },
      updateTime () {
        this.polling = setInterval(() => {
          this.currentT = moment().tz(this.channel.tz)
          this.currentUnixTime = moment().utc().unix() * 1000
          this.findCurrentEvent()
          this.getNewEvents()
        }, 5 * 1000)
      },
      findCurrentEvent () {
        if (!this.channel.timezone || !this.channel.timezone.name) return
        const t = moment().utc().unix() * 1000
        this.currentEvent = null
        for (let j = 0; j < this.allEvents.length; j += 1) {
          const event = this.allEvents[j]
          if (t >= event.startOriginal && t <= event.endOriginal) {
            this.currentEvent = event
            break
          }
        }
        if (!this.currentEvent) {
        // this.toolbarCurrentEvent();
        }
      },
      processEvent (p) {
        const program = processProgram2(p)
        const start = moment(program.startTime).utc().unix() * 1000
        const end = moment(program.endTime).utc().unix() * 1000

        return {
          id: program.id,
          color: '#eceff1',
          start: start - this.tzOffset,
          end: end - this.tzOffset,
          startOriginal: start,
          endOriginal: end,
          program,
          // rule: p.rule ? processRule(p.rule) : {},
          fixed: p.fixed,
          timed: true,
          t: true,
        }
      },
      getEvents ({ start, end }, chEvent) {
        const min = new Date(`${start.date}T00:00:00`).getTime()
        const max = new Date(`${end.date}T23:59:59`).getTime()

        const events = []
        for (let j = 0; j < this.allEvents.length; j += 1) {
          const event = this.allEvents[j]
          if ((event.start > min && event.start < max) ||
            (event.end > min && event.end < max)) {
            events.push(event)
          }
        }

        this.events = events

        let index = 0
        if (chEvent > 0) {
          for (let j = 0; j < this.events.length; j += 1) {
            if (this.events[j].id === chEvent) {
              index = j
              break
            }
          }
        }

        if (chEvent) {
          if (this.events.length > 0) {
            this.changeEvent({ event: this.events[index] })
          } else {
            this.newEventDialog = true
          }
        }
      },
      getPrograms (init) {
        if (!this.week.days) return

        this.$store.commit('setPageLoader')

        const params = {
          'end_time[gt]': `${moment(this.week.days[0].start).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'start_time[lt]': `${moment(this.week.days[this.week.days.length - 1].end).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'channel.id[eq]': this.channel.id,
          $expand: 'items',
        }
        this.$store.dispatch('programs2', params)
          .then((programs) => {
            this.allEvents = programs.map((p) => this.processEvent(p))
            this.calcGaps()
            const day = init ? this.currentDay : this.week.days[0].v
            if (this.channel.autoScheduler) {
              this.calcDayAutoScheduler(init ? this.currentDayObj : this.week.days[0], true)
            } else {
              this.getEvents({
                start: { date: day },
                end: { date: day },
              }, true)
            }
            this.findCurrentEvent()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getNewEvents () {
        if (!this.channel.autoScheduler) return

        if (this.week.text !== this.weekObj.text) {
          return
        }

        let lastId = 0
        if (this.allEvents.length) {
          lastId = this.allEvents[this.allEvents.length - 1].id
        }
        const params = {
          'channel.id[eq]': this.channel.id,
          $expand: 'items',
        }
        if (lastId > 0) {
          params['id[gte]'] = lastId
        } else {
          params['start_time[gt]'] = `${moment((moment().unix() - 10 * 60) * 1000).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`
        }
        this.$store.dispatch('programs2', params)
          .then((programs) => {
            const newEvents = programs.map((p) => this.processEvent(p))
            // eslint-disable-next-line no-nested-ternary
            newEvents.sort((a, b) => ((a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0)))
            if (this.allEvents.length) {
              const lastEvent = this.allEvents[this.allEvents.length - 1]
              for (let i = 0; i < newEvents.length; i += 1) {
                if (newEvents[i].id === lastEvent.id) {
                  for (let j = i + 1; j < newEvents.length; j += 1) {
                    this.allEvents.push(newEvents[j])
                  }
                  this.calcDayAutoScheduler(this.currentDayObj)
                  break
                }
              }
            }
          })
          .catch((errorMsg) => {
            console.log('get new events error', errorMsg)
          })
      },
      changeDay (day) {
        this.dayLoading = true
        this.currentDayObj = day
        this.calendarDay = day.v
        if (this.channel.autoScheduler) {
          this.calcDayAutoScheduler(day, true)
        }
        this.dayLoading = false
      },
      calcDay2 () {
        let tz = 'UTC'
        if (this.channel.timezone) {
          tz = this.channel.timezone.name
        }

        const now = moment.tz(tz)

        this.someDay.start = now.clone().startOf('day').valueOf()
        this.someDay.end = now.clone().endOf('day').valueOf()
        this.someDay.startT = now.clone().startOf('day')
        this.someDay.endT = now.clone().endOf('day')

        this.someDay.overlays = []
        this.someDay.gapsDuration = 0
        this.someDay.gaps = 0
        this.someDay.events = 0
        this.someDay.occupancy = 0

        const events = []

        // - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000

        const offset = new Date().getTimezoneOffset() * 60 * 1000

        for (let j = 0; j < this.schedule.length; j += 1) {
          const event = this.schedule[j]

          console.log('event.startT.getTime()', event.startT, event.startT.getTime() - offset)

          if ((event.startT.getTime() - offset > this.someDay.start && event.startT.getTime() - offset < this.someDay.end) ||
            (event.endT.getTime() - offset > this.someDay.start && event.endT.getTime() - offset < this.someDay.end)) {
            events.push(event)
          }
        }

        this.someDay.events = events.length

        if (events.length > 0) {
          let maxEnd = events[0].endT.getTime() - offset
          let opens = []
          opens.push(events[0])

          if (events[0].startT.getTime() - offset > this.someDay.start) {
            const gapDuration = events[0].startT.getTime() - offset - this.someDay.start
            if (gapDuration > 0) {
              this.someDay.gaps += 1
              this.someDay.gapsDuration += gapDuration
            }

            console.log('gapDuration', gapDuration / 1000)
          }

          for (let j = 1; j < events.length; j += 1) {
            const event = events[j]
            const newOpens = []
            for (let k = 0; k < opens.length; k += 1) {
              if (opens[k].endT.getTime() - offset > maxEnd) {
                maxEnd = opens[k].endT.getTime() - offset
              }
              if (event.startT.getTime() - offset < opens[k].endT.getTime() - offset) {
                this.someDay.overlays.push([event.id, opens[k].id])
                newOpens.push(opens[k])
              }
            }
            if (newOpens.length === 0) {
              const gapDuration = event.startT.getTime() - offset - maxEnd
              console.log('gapDuration', gapDuration / 1000)

              if (gapDuration > 0) {
                this.someDay.gaps += 1
                this.someDay.gapsDuration += gapDuration
              }
            }
            newOpens.push(event)
            opens = newOpens

            if (j === events.length - 1) {
              if (this.someDay.end > event.endT.getTime() - offset) {
                const gapDuration = this.someDay.end - event.endT.getTime() + offset
                console.log('gapDuration', gapDuration / 1000)

                if (gapDuration > 0) {
                  this.someDay.gaps += 1
                  this.someDay.gapsDuration += gapDuration
                }
              }
            }
          }
          if (events.length === 1 && this.someDay.end > maxEnd) {
            const gapDuration = this.someDay.end - maxEnd
            if (gapDuration > 0) {
              this.someDay.gaps += 1
              this.someDay.gapsDuration += gapDuration
            }
          }
        } else {
          this.someDay.gaps += 1
          this.someDay.gapsDuration += this.someDay.end - this.someDay.start
        }

        // overlays
        const overlayMap = {}
        for (let i = 0; i < this.someDay.overlays.length; i += 1) {
          overlayMap[this.someDay.overlays[i][0]] = 1
          overlayMap[this.someDay.overlays[i][1]] = 1
        }
        this.someDay.overlayMap = overlayMap

        const gapPr = (this.someDay.gapsDuration * 100) / (60 * 60 * 24 * 1000)
        this.someDay.occupancy = Math.round((100 - gapPr) * 100) / 100
      },

      calcDay (day) {
        // eslint-disable-next-line no-param-reassign
        day.overlays = []
        // eslint-disable-next-line no-param-reassign
        day.gapsDuration = 0
        // eslint-disable-next-line no-param-reassign
        day.gaps = 0
        // eslint-disable-next-line no-param-reassign
        day.events = 0
        // eslint-disable-next-line no-param-reassign
        day.occupancy = 0

        // сортируем
        // eslint-disable-next-line no-nested-ternary,max-len
        this.allEvents.sort((a, b) => ((a.startOriginal > b.startOriginal) ? 1 : ((b.startOriginal > a.startOriginal) ? -1 : 0)))

        const events = []

        for (let j = 0; j < this.allEvents.length; j += 1) {
          const event = this.allEvents[j]
          event.topBorder = 0
          event.jumpUp = 0
          // eslint-disable-next-line max-len
          if ((event.startOriginal > day.start && event.startOriginal < day.end) ||
            (event.endOriginal > day.start && event.endOriginal < day.end)) {
            events.push(event)
          }
          if (j > 0) {
            if (event.startOriginal === this.allEvents[j - 1].endOriginal) {
              event.topBorder = 1
            } else if (this.allEvents[j - 1].endOriginal - event.startOriginal < 6 * 60 * 60 * 1000) {
              event.jumpUp = 1
            }
          } else {
            event.topBorder = 1
          }
        }

        // eslint-disable-next-line no-param-reassign
        day.events = events.length

        if (events.length > 0) {
          let maxEnd = events[0].endOriginal
          let opens = []
          opens.push(events[0])

          if (events[0].startOriginal > day.start) {
            const gapDuration = events[0].startOriginal - day.start
            if (gapDuration > 0) {
              // eslint-disable-next-line no-param-reassign
              day.gaps += 1
              // eslint-disable-next-line no-param-reassign
              day.gapsDuration += gapDuration
            }
          }

          for (let j = 1; j < events.length; j += 1) {
            const event = events[j]
            const newOpens = []
            for (let k = 0; k < opens.length; k += 1) {
              if (opens[k].endOriginal > maxEnd) {
                maxEnd = opens[k].endOriginal
              }
              if (event.startOriginal < opens[k].endOriginal) {
                day.overlays.push([event.id, opens[k].id])
                newOpens.push(opens[k])
              }
            }
            if (newOpens.length === 0) {
              const gapDuration = event.startOriginal - maxEnd
              if (gapDuration > 0) {
                // eslint-disable-next-line no-param-reassign
                day.gaps += 1
                // eslint-disable-next-line no-param-reassign
                day.gapsDuration += gapDuration
              }
            }
            newOpens.push(event)
            opens = newOpens

            if (j === events.length - 1) {
              if (day.end > event.endOriginal) {
                const gapDuration = day.end - event.endOriginal
                if (gapDuration > 0) {
                  // eslint-disable-next-line no-param-reassign
                  day.gaps += 1
                  // eslint-disable-next-line no-param-reassign
                  day.gapsDuration += gapDuration
                }
              }
            }
          }
          if (events.length === 1 && day.end > maxEnd) {
            const gapDuration = day.end - maxEnd
            if (gapDuration > 0) {
              // eslint-disable-next-line no-param-reassign
              day.gaps += 1
              // eslint-disable-next-line no-param-reassign
              day.gapsDuration += gapDuration
            }
          }
        } else {
          // eslint-disable-next-line no-param-reassign
          day.gaps += 1
          // eslint-disable-next-line no-param-reassign
          day.gapsDuration += day.end - day.start
        }

        // overlays
        const overlayMap = {}
        for (let i = 0; i < day.overlays.length; i += 1) {
          overlayMap[day.overlays[i][0]] = 1
          overlayMap[day.overlays[i][1]] = 1
        }
        // eslint-disable-next-line no-param-reassign
        day.overlayMap = overlayMap

        const gapPr = (day.gapsDuration * 100) / (60 * 60 * 24 * 1000)
        // eslint-disable-next-line no-param-reassign
        day.occupancy = Math.round((100 - gapPr) * 100) / 100
      },
      calcDayAutoScheduler (day, chEvent = false) {
        const dayStart = day.start
        const dayEnd = day.end

        this.events = []

        // eslint-disable-next-line no-nested-ternary,max-len
        this.allEvents.sort((a, b) => ((a.startOriginal > b.startOriginal) ? 1 : ((b.startOriginal > a.startOriginal) ? -1 : 0)))

        const events = []

        for (let i = 0; i < this.allEvents.length; i += 1) {
          const event = this.allEvents[i]
          if ((event.startOriginal > dayStart && event.startOriginal < dayEnd) ||
            (event.endOriginal > dayStart && event.endOriginal < dayEnd)) {
            events.push(event)
          }
        }

        // eslint-disable-next-line no-param-reassign
        day.events = events.length

        const gapEvents = []
        if (events.length > 0) {
          for (let i = 0; i < events.length; i += 1) {
            const event = events[i]
            if (i !== events.length - 1) {
              if (i === 0 && event.startOriginal - dayStart > 60) {
                gapEvents.push({
                  program: {
                    name: '---',
                    subType: '',
                  },
                  start: dayStart - this.tzOffset,
                  end: event.start,
                })
              }
              if (events[i + 1].startOriginal - event.endOriginal > 60) {
                gapEvents.push({
                  program: {
                    name: '---',
                    subType: '',
                  },
                  start: event.end,
                  end: events[i + 1].start,
                })
              }
            } else if (dayEnd - event.endOriginal > 60) {
              gapEvents.push({
                program: {
                  name: '---',
                  subType: '',
                },
                start: event.end,
                end: dayEnd - this.tzOffset,
              })
            }
            // overlays
            // eslint-disable-next-line no-prototype-builtins
            if (day.overlayMap && day.overlayMap.hasOwnProperty(event.id)) {
              event.overlap = 1
            }
          }
        } else {
          gapEvents.push({
            program: {
              name: '---',
              subType: '',
            },
            start: dayStart - this.tzOffset,
            end: dayEnd - this.tzOffset,
          })
        }

        const allEvents = events.concat(gapEvents)
        // eslint-disable-next-line no-nested-ternary
        allEvents.sort((a, b) => ((a.start < b.start) ? 1 : ((b.start < a.start) ? -1 : 0)))
        this.events = allEvents
        if (this.events.length > 0 && chEvent) {
          let noEvents = true
          for (let i = 0; i < this.events.length; i += 1) {
            if (this.events[i].id) {
              this.changeEventFromAutoScheduler(this.events[i])
              noEvents = false
              break
            }
          }
          if (noEvents) {
            this.newEventDialog = true
          }
        }
      },
      calcGaps (selectedDays) {
        for (let i = 0; i < this.week.days.length; i += 1) {
          const day = this.week.days[i]

          if (selectedDays && selectedDays.length && !selectedDays.includes(day.v)) {
            // eslint-disable-next-line no-continue
            continue
          }
          this.calcDay(day)
        }
      // this.getWeeksStat();
      },
      changeEventFromAutoScheduler (event) {
        if (!event.id) return
        const args = {
          id: event.id,
          $expand: '*',
        }
        this.$store.dispatch('getProgram2ById', args)
          .then((program) => {
            event.program = processProgram2(program)
            for (let i = 0; i < event.program.items.length; i += 1) {
              const item = event.program.items[i]
              if (item.assetResource && item.assetResource.state === 'ready') {
                item.streamURL = item.assetResource.streamURL
              }
            }
          })
          .catch((errorMsg) => {
            console.log('error getting program details', errorMsg)
          })
          .finally(() => this.changeEvent({ event }))
      },
      changeEvent ({ event }) {
        if (event.id === 'new') return
        this.newEventDialog = false
        // this.removeNewEvent();
        this.selectedEvent.event.color = '#eceff1'
        this.selectedEvent.event = event

        this.selectedEvent.date = moment(event.start).format('YYYY-MM-DD')
        this.selectedEvent.time = moment(event.start).format('HH:mm:ss')
        if (moment(event.start).format('DD') !== moment(event.end).format('DD')) {
          this.calendarDay = this.calendarDay === moment(event.start).format('YYYY-MM-DD') ? this.calendarDay : moment(event.end).format('YYYY-MM-DD')
        } else {
          this.calendarDay = moment(event.start).format('YYYY-MM-DD')
        }
        this.selectedEvent.event.color = 'primary'
        // this.selectedEvent.nextEvents = this.getNextEvents(this.selectedEvent.event.id);

        if (!event.program.duration) {
          // eslint-disable-next-line no-param-reassign
          event.loading = true
          this.$store.dispatch('programs/getProgram', event.id)
            .then((e) => {
              // eslint-disable-next-line no-param-reassign
              event = this.processEvent(e)
              this.selectedEvent.event = event
              this.selectedEvent.event.color = 'primary'
              // eslint-disable-next-line no-param-reassign
              event.loading = false
            })
            .catch((errorMsg) => {
              // eslint-disable-next-line no-param-reassign
              event.loading = false
              console.log('error getting event', event.id, errorMsg)
            })
        }
      },
      dayColor (day) {
        if (day.occupancy === undefined) return 'grey'
        if (day.occupancy >= 90) return 'green darken-3'
        if (day.occupancy >= 50 && day.occupancy < 90) return 'orange darken-2'
        return 'red darken-2'
      },
      iconError () {
        this.channel.icon = this.defaultIcon
      },
      setActiveCol (i) {
        this.activeCol = i
      },
      goToRules () {
        this.$router.push({
          name: 'ChannelEditPage',
          params: {
            id: this.channel.id,
          },
          query: {
            tab: 1,
          },
        })
      },
      deleteEvent (id) {
        this.schedule = this.schedule.filter(e => e.id !== id)
        this.checkConflicts1()
      },
      playStreamByURL (stream, name, description) {
        const link = stream.replace(/^http:\/\//, 'https://')

        this.player.name = name
        this.player.description = description
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
        this.openPlayer = true
      },
      closeStream () {
        this.openPlayer = false
        this.frameSrc = '/js/radiant/index.html?src='
      },
      handleDayClick (date) {
        console.log('Выбрана дата:', date)
        // this.selectedDate = date
        // и т.п.

        let tz = 'UTC'
        if (this.channel.timezone) {
          tz = this.channel.timezone.name
        }

        // const m = moment.tz(date, tz); // дата с привязкой к таймзоне

        const m = moment(date)

        console.log('m', m)

        this.someDay.start = m.clone().startOf('day').valueOf()
        this.someDay.end = m.clone().endOf('day').valueOf()
        this.someDay.startT = m.clone().startOf('day')
        this.someDay.endT = m.clone().endOf('day')

        this.someDay.overlays = []
        this.someDay.gapsDuration = 0
        this.someDay.gaps = 0
        this.someDay.events = 0
        this.someDay.occupancy = 0

        this.schedule = []

        const start = moment(`${m.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000
        console.log('start', start)
        const end = m.clone().endOf('day').valueOf()
        // const end = moment(`${t.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000

        const newDay = {
          v: m.format('YYYY-MM-DD'),
          text: m.format('MMMM D'),
          start,
          end,
          overlays: [],
          gaps: 0,
          gapsDuration: 0,
          events: 0,
        }
        this.currentDayObj = newDay

        console.log(' this.currentDayObj', this.currentDayObj.v)
      },
      editEventTime (event) {
        this.editedEvent = event
        this.editedStart = event.start
        this.editDialog = true
      },
      saveEditedTime () {
        const [h, m] = this.editedStart.split(':').map(Number)
        if (isNaN(h) || isNaN(m)) return

        this.editedEvent.start = this.editedStart
        this.editedEvent.startT.setHours(h, m, 0, 0)
        this.editedEvent.endT = new Date(this.editedEvent.startT.getTime() + this.editedEvent.duration * 60000)
        this.editedEvent.end = this.formatTime(this.editedEvent.endT)

        this.editDialog = false
        this.editedEvent = null
        this.checkConflicts1()
      },
    },
  }
</script>

<style>
  .v-event-draggable {
    user-select: none;
    -webkit-user-select: none;
    padding-left: 6px;
  }

  .v-event-top-docked {
    border-top: 1px solid grey !important;
  }

  .v-event-draggable img
  {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 50px;
  }

  .v-radio .v-label {
    padding-top: 8px !important;
  }

  .newprogramm .v-input--checkbox .v-input__control label {
    padding-top: 8px !important;
  }

  .day-table {
    width: 100%;
  }
  .asset-table tr td {
    cursor: pointer;
  }
  .next-events {
    width: 100%;
  }
  .next-events td {
    vertical-align: top;
    line-height: normal !important;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .next-events tr:last-child td {
    border-bottom: 0;
  }
  .next-events td span {
    display: inline;
    float: left;
  }
  .vjs-custom-skin video {
    max-width: 960px !important;
  }
  .rule-table {
    width: 100%;
  }
  .rule-table tr {
    background-color: #eeeeee;
  }
  .rule-table tr td {
    padding: 5px 10px;
  }
  .rule-table tr:hover {
    cursor: pointer;
    background-color: #e6eef8;
    color: #2e67c0;
  }
  .text-no-wrap * {
    float: left;
  }
  .selected-day {
    background-color: #f0f6fc !important;
  }
  .v-calendar-daily_head-weekday {
    display: none !important;
  }
  .weeks .v-card:not(.on-hover) {
    opacity: 0.9;
  }
  .weeks .show-btns {
    color: rgba(255, 255, 255, 1) !important;
  }
  .current-week {
    background-color: #f0f6fc !important;
  }
  .table-scheduler {
    width: 100%;
    display: block;
  }
  .table-scheduler tbody {
    width: 100%;
    min-height: 150px;
    max-height: 775px;
    display: inline-block;
    overflow-y: auto;
    overflow-x: auto;
  }
  .table-scheduler tbody tr {
    width: 100%;
  }
  .table-scheduler tbody td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .table-scheduler tbody td:last-child {
    width: 100%;
  }
  .v-current-time {
    height: 2px;
    background-color: #ea4335;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;
  }
  .first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.source-block {
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 20px;

  padding: 8px;
  background: #f9fbfd;
  border: 1px solid #e3eaf3;
  border-radius: 8px;
}

  .asset-panel {

  }
  .asset-panel h2 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #1a202c;
  }

.source-item1 {
  background-color: #e2e6ea;
  padding: 8px;
  margin-bottom: 5px;
  cursor: grab;
  border: 1px solid #ccc;
  border-radius: 4px;
}

  .source-item {
    background-color: #f5f9ff;
    border: 1px solid #c3dafe;
    padding: 10px 12px;
    margin-bottom: 8px;
    border-radius: 6px;
    cursor: grab;
    transition: background 0.2s;

    background-color: white;
    border: 1px solid #d6e4f5;
    border-left: 4px solid #1a73e8;
    margin-bottom: 10px;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    cursor: grab;
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
  }

  .source-item:hover {
    background-color: #e8f0fe;
    background-color: #f0f7ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.draggable-row {
  cursor: move;
}
  .no-column-borders td,
  .no-column-borders th {
    border-left: none;
    border-right: none;
  }

  .no-column-borders tr td:first-child,
  .no-column-borders tr th:first-child {
    border-left: 1px solid #dee2e6;
  }

  .no-column-borders tr td:last-child,
  .no-column-borders tr th:last-child {
    border-right: 1px solid #dee2e6;
  }

  .relative { position: relative; }
  .absolute { position: absolute; }
  .timeline {
    position: relative;
    height: 35px;
   background: #f5f5f5;
    overflow: hidden;
  }
  .timeline-grid {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
  }
  .tick {
    flex: 1;
    border-left: 1px solid #ddd;
    height: 100%;
  }
  .tick.hour {
    border-right: 2px solid #999;
  }
  .timeline-labels {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #444;
    pointer-events: none;
  }
  .label {
    flex: 1;
    text-align: left;
  }
  .timeline-fill {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 40%;
    width: 100%;
  }
  .fill {
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: #81c784;
    border-radius: 4px;
  }
  .non-draggable {
    cursor: default;
    /* другие стили, если необходимо */
  }
  .anchor-gradient {
    background: linear-gradient(90deg, rgba(245,158,11,0.2), rgba(255,255,255,0));
    border-left: 4px solid rgba(245,158,11,0.6);
  }

  .gap-indicator {
    border-bottom: 3px dashed #ddd;
  }

  .anchor-gradient {
    background: linear-gradient(to right, #fff8e1, #ffecb3);
    background: linear-gradient(to right, #e3f2fd, #bbdefb);

  }

  .anchor-gradient {
    background-color: #f0f7ff !important;
    border-left: 3px solid #42a5f5;
  }

  .gap-indicator7 {
    background-color: #fff3e0;
    border-top: 1px dashed #ffa726;
    border-bottom: 1px dashed #ffa726;
    color: #bf360c;
  }

  .schedule-table thead th {
    font-size: 14px;
    font-weight: 600;
    background: #f5f5f5;
    padding: 10px 8px;
    border-bottom: 2px solid #ddd;
  }

  .schedule-table td:first-child,
  .schedule-table td:nth-child(2) {
    width: 60px;
    text-align: center;
  }

  .conflict-badge {
    background: #ffebee;
    color: #c62828;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
  }
  .overflow-row {
    background-color: #ffebee;
    border-left: 4px solid #e53935;
  }

  .asset-tile {
    display: flex;
    align-items: center;
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-bottom: 6px;
    background: white;
    position: relative;
    cursor: grab;
    user-select: none;

    background-color: #f5f9ff;
    border: 1px solid #c3dafe;
    padding: 2px;
    margin-bottom: 2px;
    border-radius: 6px;
    cursor: grab;
    transition: background 0.2s;

    background-color: white;
    border: 1px solid #d6e4f5;
    border-left: 4px solid #1a73e8;
    margin-bottom: 10px;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    cursor: grab;
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
  }

  .asset-tile .bar {
    width: 4px;
    height: 100%;
    background-color: #2196f3; /* синий акцент */
    border-radius: 2px;
    margin-right: 12px;
  }

  .asset-tile .text {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }


  .asset-tile:hover {
    background-color: #e8f0fe;
    background-color: #f0f7ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

</style>
